import { useContext } from 'react';
import { GoogleAnalyticsContext } from '../providers/GoogleAnalyticsProvider';
function useGoogleAnalytics() {
    return useContext(GoogleAnalyticsContext);
}
export default useGoogleAnalytics;
